/**
 * Facebookページプラグインの再描画処理
 * 親要素の幅が正しく検出されるように、SDK読み込み後にプラグインを再描画する
 */

const reRenderFacebookPlugin = () => {
  if (typeof FB === 'undefined') {
    return;
  }

  const fbPageElements = document.querySelectorAll('.fb-page');
  if (fbPageElements.length === 0) {
    return;
  }


  // 親要素の幅を計算してプラグインを再描画
  fbPageElements.forEach((element, index) => {
    const parent = element.closest('[class*="facebook"]') || element.parentElement;
    if (parent) {
      const parentWidth = parent.offsetWidth;
      
      if (parentWidth > 0) {
        // 親要素の幅が500px未満の場合は、data-widthを削除してdata-adapt-container-widthに任せる
        // 親要素の幅が500px以上の場合は、data-width="500"を設定（最大500px）
        if (parentWidth < 500) {
          element.removeAttribute('data-width');
        } else {
          element.setAttribute('data-width', '500');
        }
        
        // プラグインを再描画
        // 親要素を指定して再描画
        FB.XFBML.parse(parent);
      }
    }
  });
};

const waitForFacebookSDK = () => {
  return new Promise((resolve) => {
    if (typeof FB !== 'undefined') {
      resolve();
      return;
    }

    // fbAsyncInitが既に設定されているか確認
    const originalFbAsyncInit = window.fbAsyncInit;
    
    window.fbAsyncInit = function() {
      // 既存のfbAsyncInitがあれば実行
      if (typeof originalFbAsyncInit === 'function') {
        originalFbAsyncInit();
      }
      
      // FB.initが呼ばれるまで少し待機
      setTimeout(() => {
        if (typeof FB !== 'undefined') {
          resolve();
        }
      }, 100);
    };

    // SDKが既に読み込まれている可能性がある場合のフォールバック
    let checkCount = 0;
    const checkInterval = setInterval(() => {
      checkCount++;
      if (typeof FB !== 'undefined') {
        clearInterval(checkInterval);
        resolve();
      } else if (checkCount > 50) {
        // 5秒待っても読み込まれない場合はタイムアウト
        clearInterval(checkInterval);
        console.warn('Facebook SDK did not load within 5 seconds');
        resolve(); // Promiseを解決して処理を続行
      }
    }, 100);
  });
};

const initFacebookPlugin = async () => {
  
  // Facebook SDKが読み込まれるまで待機
  await waitForFacebookSDK();
  
  
  // レイアウトが確定するまで待機
  await new Promise(resolve => setTimeout(resolve, 500));
  
  // プラグインを再描画
  reRenderFacebookPlugin();
  
  // ウィンドウのリサイズ時にも再描画（デバウンス付き）
  let resizeTimer = null;
  window.addEventListener('resize', () => {
    if (resizeTimer) {
      clearTimeout(resizeTimer);
    }
    resizeTimer = setTimeout(() => {
      reRenderFacebookPlugin();
    }, 200);
  });
};

// DOMContentLoaded時に実行
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFacebookPlugin);
} else {
  initFacebookPlugin();
}

